import { FiWordImportComponent } from './handbook-import/word-import/word-import.component';
import { FiHandbookImportComponent } from './handbook-import/handbook-import.component';
import { SystemObjectsImportComponent } from '@fi-app/import/system-objects-import/system-objects-import.component';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { MindMapImportComponent } from '@fi-app/import/handbook-import/mind-map-import/mind-map-import.component';
import { Ng2StateDeclaration, StatesModule } from '@uirouter/angular';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiWordExportComponent } from '@fi-app/import/handbook-import/fi-word-export/fi-word-export.component';

export function CustomImportSystemObjectsPageTitle(ccmPageTitle: PageTitleService) {
    ccmPageTitle.setTitleByTextId('module.organization_import');
}

export function CustomMindMapImportPageTitle(ccmPageTitle: PageTitleService) {
    ccmPageTitle.setTitleByTextId('import.mind_manager');
}

export function WordImportPageTitle(ccmPageTitle: PageTitleService) {
    ccmPageTitle.setTitleByTextId('import.mind_manager');
}

const ImportState: Ng2StateDeclaration = {
    name: FiStateNames.Import._name,
    url: '/Import',
    abstract: true,
    parent: FiStateNames.GlobalSettings,
    component: FiAbstractStateComponent,
};

export const ImportStates: StatesModule = {
    states: [
        ImportState,
        {
            name: FiStateNames.Import.SystemObject,
            url: '/SystemObject',
            views: {
                '@': {
                    component: SystemObjectsImportComponent,
                },
            },
            resolve: {
                pageTitle: [PageTitleService, CustomImportSystemObjectsPageTitle],
            },
        },
        {
            name: FiStateNames.Import.Handbook._name,
            url: '/Handbook',
            abstract: true,
            views: {
                '@': {
                    component: FiHandbookImportComponent,
                },
            },
        },
        {
            name: FiStateNames.Import.Handbook.MindMap,
            url: '/MindMap',
            component: MindMapImportComponent,
            resolve: {
                pageTitle: [PageTitleService, CustomMindMapImportPageTitle],
            },
        },
        {
            name: FiStateNames.Import.Handbook.Word,
            url: '/Word',
            component: FiWordImportComponent,
            resolve: {
                pageTitle: [PageTitleService, WordImportPageTitle],
            },
        },
        {
            name: FiStateNames.Import.Handbook.WordExport,
            url: '/WordExport',
            component: FiWordExportComponent,
            resolve: {},
        },
    ],
};

export function registerImportStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.Import.SystemObject], {
        SettingType: [ApplicationSettingsType.CoreGlobal],
        AccessType: AccessRightType.Admin,
    });

    stateAccessCheckService.registerStateRules(
        [FiStateNames.Import.Handbook.MindMap, FiStateNames.Import.Handbook.Word],
        {
            SettingType: [ApplicationSettingsType.CoreGlobal],
            AccessType: AccessRightType.Admin,
        },
    );
}
